<template>
  <div class="loading-overlay visible">
      <ocLogo :animated="true"></ocLogo>
  </div>
</template>

<script>
import ocLogo from '../components/oc-logo'

export default {
  name: 'Upgrade',
  components: {
    ocLogo
  },
  data () {
    return {
    }
  },
  methods: {

  },
  mounted: function () {
    if (typeof (this.$route.params.email) !== 'undefined' && typeof (this.$route.params.instanceId) !== 'undefined') {
      let instanceId = this.$route.params.instanceId

      if (instanceId.indexOf('https://') > -1) {
        instanceId = instanceId.substr(8)
      }

      if (instanceId.substr(instanceId.length - 1, 1) === '/') {
        instanceId = instanceId.substr(0, instanceId.length - 1)
      }

      this.$store.state.customer.instanceId = instanceId
      this.$store.state.customer.email = this.$route.params.email
      this.$store.state.customer.state = 'upgrade'
      this.$router.push({ name: 'Buy', params: { package: 'advanced' } })
    } else {
      this.$store.state.customer.instanceId = ''
      this.$store.state.customer.email = ''
      this.$store.state.customer.state = ''
      this.$router.push({ name: 'Buy', params: { package: 'advanced' } })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
